import { IntlShape } from 'react-intl';
import { decodeHTML } from 'entities';
import supportedLanguages from '@whitelabel/helpers/supportedLanguages';
import { ICurrency } from './types/currencyTypes';

export const localizePathname = (pathname: string, locale: string) => {
  const pathnameArray = pathname.split('/');
  if (Object.keys(supportedLanguages).includes(pathnameArray[1])) {
    pathnameArray[1] = locale;
  } else {
    pathnameArray.splice(1, 0, locale);
  }
  return pathnameArray.join('/');
};

type FormatCurrencyOptions = {
  useShortFormat?: boolean;
};

export const formatCurrency = (
  intl: IntlShape,
  value: number | bigint,
  currency: ICurrency,
  options?: FormatCurrencyOptions,
): string => {
  const { code, format, isZeroDecimal } = currency;

  const fractionDigits = isZeroDecimal ? 0 : 2;

  if (options?.useShortFormat) {
    return intl.formatNumber(value, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  const formattedValue = intl.formatNumber(value, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  const formattedCurrency = decodeHTML(format.replace(/%\.\df/, formattedValue));

  return formattedCurrency;
};
